var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuggage03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 21V7c0-.93 0-1.395.1022-1.7765a3 3 0 0 1 2.1213-2.1213C10.605 3 11.07 3 12 3s1.395 0 1.7765.1022a3 3 0 0 1 2.1213 2.1213C16 5.605 16 6.07 16 7v6.5m0 4V21m-9.2 0h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.7202 22 17.8802 22 16.2v-4.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 7 18.8802 7 17.2 7H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 9.2798 2 10.1198 2 11.8v4.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 21 5.1198 21 6.8 21m6-3.5h4.9c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.107.0545-.247.0545-.527v-2.4c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C18.12 13.5 17.98 13.5 17.7 13.5h-4.9c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C12 13.88 12 14.02 12 14.3v2.4c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185c.107.0545.247.0545.527.0545",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggage03);
export default __webpack_public_path__ + "static/media/luggage-03.975f5145c89e2751d81c817953132311.svg";
export { ForwardRef as ReactComponent };